import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "routing-addresses-list" }

import RoutingAddressCard from 'vcomponents/overview/tabs/routingAddresses/RoutingAddressCard.vue';
import type { RoutingAddress } from 'types/entities/einvoicing/routingAddress.type';

interface Props {
    addresses: RoutingAddress[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RoutingAddressesList',
  props: {
    addresses: {}
  },
  emits: ["setDefault"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.addresses, (address) => {
      return (_openBlock(), _createBlock(RoutingAddressCard, {
        key: address.id,
        address: address,
        onSetDefault: _cache[0] || (_cache[0] = (id) => emit('setDefault', id))
      }, null, 8 /* PROPS */, ["address"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})